import { MonitorBase } from './_MonitorBase';

export class MonitorDevice extends MonitorBase {
  constructor(game, parent, config) {
    super(game, parent, { label: 'device', ...config });
    this.updateMonitor();
  }

  updateMonitor() {
    let deviceString = `${this.game.isLowEndDevice ? 'Low-end' : 'High-end'}, ${
      this.game.renderer.type == '1' ? 'Canvas' : 'WebGL'
    }`;
    if (navigator.deviceMemory) {
      deviceString += `, RAM : ${navigator.deviceMemory} gb`;
    }
    this.setValue(deviceString);
  }

  getLog() {
    const device = this.game.device;
    const OS = Object.keys(device.os).filter((k) => device.os[k] === true);
    const browser = Object.keys(device.browser).filter((k) => device.browser[k] === true);
    browser.forEach((entry, i) => {
      if (device.browser[entry + 'Version']) {
        browser[i] = `${entry} v${device.browser[entry + 'Version']}`;
      }
    });
    let str = '';
    str += `OS\t\t\t: ${OS.join(', ')}`;
    str += `${this.game.isLowEndDevice ? 'Low-end' : 'High-end'}`;
    str += `${this.game.renderer.type == '1' ? 'Canvas' : 'WebGL'}`;
    str += `\nest. RAM\t: ${navigator.deviceMemory} gb`;
    str += `\nbrowser\t\t: ${browser.join(', ')}`;
    str += `\nuser agent\t: ${navigator.userAgent}`;

    return str;
  }
}
